/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThresholdAlertListResponse {
    getFixupPrototypeFunction() { return ThresholdAlertListResponse.fixupPrototype; }

    static newInstance(model: Partial<ThresholdAlertListResponse>): ThresholdAlertListResponse {
        let obj = Object.assign(new ThresholdAlertListResponse(), model);
        ThresholdAlertListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThresholdAlertListResponse>): ThresholdAlertListResponse {
        if (!model) return null;
        return ThresholdAlertListResponse.newInstance(<ThresholdAlertListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThresholdAlertListResponse) {
        if (!obj) return;

        models.ThresholdAlertListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThresholdAlertListResponse): boolean {
        Object.setPrototypeOf(obj, ThresholdAlertListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold_details) {
            for (let val of this.threshold_details) {
                models.ThresholdAlertListModel.fixupPrototype(val);
            }
        }
    }

    /**
     * Threshold Details
     */
    threshold_details: Array<models.ThresholdAlertListModel>;

}
